module.exports = {"platforms":[{"message":"start platform","type":"FiniteImmobilePlatform","x":7,"y":10,"width":10,"height":1,"display":{"assetName":"lanterns"}}],"obstacles":[{"message":"barrier","type":"laser","x":12,"y":4,"dx":0,"dy":1}],"player":{"x":8,"y":9},"goal":{"x":15,"y":10},"par":1,"scale":32}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/friend-10-laser-4.json
// module id = 136
// module chunks = 0